/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccreditationUpdateAliases {
  ACTION_REQUEST_UPDATE = 'action-request-update',
  AUTOCOMPLETE_0 = 'autocomplete-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_ACCREDITATIONS = 'deck-accreditations',
  FETCH_0 = 'fetch-0',
  FETCH_SITUATION = 'fetch-situation',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_3 = 'field-3',
  FILTER_ACCREDITATION_UPDATE = 'filter-accreditation-update',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD_ACCREDITATIONS = 'hpms-custom-card-accreditations',
  MAPPER_0 = 'mapper-0',
  PANEL_ACCREDITATION_UPDATE = 'panel-accreditation-update',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_3 = 'text-3',
}
export { AccreditationUpdateAliases };
